import React from 'react';
import { StyledPlatformHero } from './contentPageHero.styles';
import cn from 'classnames';

interface IContentPageHeroProps {
	title: string;
	subtitle: string;
	text?: string;
	isFullPage?: boolean;
}

export const ContentPageHero = ({
	subtitle,
	title,
	text,
	isFullPage,
}: IContentPageHeroProps) => {
	return (
		<StyledPlatformHero
			className={cn({
				'full-width': isFullPage,
			})}
		>
			<div className={cn('hero-wrapper')}>
				<h1>{title}</h1>
				<h2>{subtitle}</h2>
				{text && <p>{text}</p>}
			</div>
		</StyledPlatformHero>
	);
};
